import { createFileRoute } from "@tanstack/react-router";
import { FleetManagementPage } from "@/components/fleet/fleet-management-page";

function DriversPage() {
  return <FleetManagementPage initialTab="drivers" showTabs={false} />;
}

export const Route = createFileRoute("/_app/drivers")({
  component: DriversPage,
});
